import { useMutation } from '@gogame/query';

import * as CREATIVES from 'scenes/Gallery/GalleryPage/Creatives/constants';
import { linkCreative } from 'scenes/Gallery/GalleryPage/Creatives/sources/creatives';
import { createCreative } from 'scenes/Gallery/GalleryPage/Creatives/sources/creatives';

import { create } from '../queryKeyFactory';

export const useCreate = () => {
  const createCreatives = async ({ creatives, conceptId }) => {
    return Promise.all(
      creatives.map(async (creative) => {
        const {
          /* eslint-disable-next-line */
          [CREATIVES.FILE]: _,
          [CREATIVES.FILE_GUID]: fileGuid,
          ...creativeFields
        } = creative;
        const creativeGuid = await createCreative({
          ...creativeFields,
          conceptId,
        });

        return await linkCreative({ fileGuid, creativeGuid });
      })
    );
  };

  const mutation = useMutation(create(), createCreatives, {
    successMessage: () => 'Creatives created',
  });
  return [mutation.mutateAsync, mutation];
};
